module.exports = function () {

    if ($('.main-header--2025').length === 0) {
        return;
    }

    function isHamburgerMenuOpen() {
        return $('.main-nav__hamburger').hasClass('main-nav__hamburger--is-active');
    }  

    function openHamburgerMenu() {
        $('.main-nav__hamburger').addClass('main-nav__hamburger--is-active');        
        $('body').addClass('hamburger-nav--is-active');
        $('.main-header').addClass('main-header--with-open-hamburger');

        ariaHideNonHeaderContent();        
        updateNavAccessibilityElements();
    }

    function closeHamburgerMenu() {
        closeSubnav(true);
        $('.main-nav__hamburger').removeClass('main-nav__hamburger--is-active');        
        $('body').removeClass('hamburger-nav--is-active');

        setTimeout(function () {
            $('.main-header').removeClass('main-header--with-open-hamburger');
        }, 500);

        ariaUnhideNonHeaderContent();        
        updateNavAccessibilityElements();

        if ($('.main-nav__hamburger').length > 0) {
            $('.main-nav__hamburger').first().focus();
        }
    }

    function isSearchPaneOpen() {
        return $('.main-nav__search-btn').hasClass('main-nav__search-btn--is-active');
    }

    function updateSearchWrapperHeight() {

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.hasClass('search-wrapper--is-active')) {
            var containerHeight = $searchWrapperWithSuggestions.find('.search-wrapper__container').outerHeight(true);
            
            if (containerHeight + 80 <= $('body').outerHeight(true)) {
                var containerHeightValue = containerHeight + 'px';
                $searchWrapperWithSuggestions.css('height', containerHeightValue);
            }
            else {
                $searchWrapperWithSuggestions.css('height', 'calc(100% - 80px)');
                $searchWrapperWithSuggestions.css('overflow-y', 'scroll');
            }
        }
        else {
            $searchWrapperWithSuggestions.css('height', '0');
            $searchWrapperWithSuggestions.css('overflow-y', '');
        }
    };

    function openSearchPane() {
        $('.main-nav__search-btn').addClass('main-nav__search-btn--is-active');
        $('.search-wrapper').addClass('search-wrapper--is-active');
        $('body').addClass('search-pane--is-active');
        $('.main-nav__hamburger').addClass('main-nav__hamburger--is-faded');

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.length) {
            $('.header-scrim').addClass('header-scrim--is-visible');
            $('.main-header').addClass('main-header--with-open-search');

            requestAnimationFrame(function () {
                $('.header-scrim').addClass('header-scrim--is-active');
            });

            updateSearchWrapperHeight();
        }

        ariaHideNonHeaderContent();
        updateSearchPaneAccessibilityElements();

        setTimeout(function () {
            $('.search-wrapper input').first().focus();
        }, 250);        
    }

    function closeSearchPane() {
        $('.main-nav__search-btn').removeClass('main-nav__search-btn--is-active');
        $('.search-wrapper').removeClass('search-wrapper--is-active');
        $('body').removeClass('search-pane--is-active');
        $('.main-nav__hamburger').removeClass('main-nav__hamburger--is-faded');

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.length) {            
            updateSearchWrapperHeight();
            $('.header-scrim').removeClass('header-scrim--is-active');

            setTimeout(function () {
                $('.header-scrim').removeClass('header-scrim--is-visible');
                $('.main-header').removeClass('main-header--with-open-search');
            }, 250);   
        }

        ariaUnhideNonHeaderContent();        
        updateSearchPaneAccessibilityElements();

        if ($(document.activeElement).closest('.search-wrapper').length > 0) {
            $(document.activeElement).closest('.main-header').find('.main-nav__search-btn').first().focus();
        }
    }

    function updateSearchPaneAccessibilityElements() {        
        var $focusableElements = $('.search-wrapper').find('.search-control__search-input, .search-control__search-btn, .search-list__list-item__link, .featured-result-link');

        if (isSearchPaneOpen()) {
            $('.main-nav__search-btn').attr('aria-expanded', 'true');
            $('.search-wrapper').removeAttr('aria-hidden');
            $focusableElements.attr('tabindex', '');
            setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn').add($focusableElements));
        }
        else {
            $('.main-nav__search-btn').attr('aria-expanded', 'false');
            $('.search-wrapper').attr('aria-hidden', 'true');
            $focusableElements.attr('tabindex', '-1');
            removeFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn').add($focusableElements));
        }
    }

    function isAnySubnavOpen() {
        return $('.main-nav__main-nav-item--is-active').length > 0;
    }
       
    function openSubnav(mainNavDropdownItemLink) {
        $(mainNavDropdownItemLink).parent().addClass('main-nav__main-nav-item--is-active');

        var distanceToTop = $(document).scrollTop() * -1;
        $('body').addClass('with-open-header').css('top', distanceToTop + 'px')
        
        $('.header-scrim').addClass('header-scrim--is-visible');
        $('.main-header').addClass('main-header--with-open-header');

        requestAnimationFrame(function () {
            $('.header-scrim').addClass('header-scrim--is-active');
        });

        var $subnavOuter = $(mainNavDropdownItemLink).siblings('.main-nav__main-nav-item-subnav-outer').first();

        if (!(ICF.Utils.Breakpoints.IsMobile() || ICF.Utils.Breakpoints.IsTablet())) {            
            var subnavInnerHeight = $subnavOuter.find('.main-nav__main-nav-item-subnav-inner').outerHeight(true);
            if (subnavInnerHeight + 80 <= $('body').outerHeight(true)) {
                var subnavInnerHeightValue = subnavInnerHeight + 'px';
                $subnavOuter.css('height', subnavInnerHeightValue).css('overflow-y', '');
            }
            else {
                $subnavOuter.css('height', 'calc(100% - 80px)').css('overflow-y', 'scroll');
            }
        }
        else {
            $subnavOuter.find('.main-nav__main-nav-item-subnav-back-link').first().focus();
        }

        ariaHideNonHeaderContent();        
        updateNavAccessibilityElements();
    }

    function closeSubnav(deactivateScrimAndCloseHeader) {

        if (typeof deactivateScrimAndCloseHeader === 'undefined') {
            deactivateScrimAndCloseHeader = true;
        }        

        $('body').removeClass('with-open-header').css({
            'top': ''
        });

        if (deactivateScrimAndCloseHeader) {
            $('.header-scrim').removeClass('header-scrim--is-active');
            setTimeout(function () {
                $('.header-scrim').removeClass('header-scrim--is-visible');
            }, 250);

            setTimeout(function () {
                $('.main-header').removeClass('main-header--with-open-header');
            }, 600);
        }

        $('.main-nav__main-nav-item-link').each(function (i, el) {
            $(this).parent().removeClass('main-nav__main-nav-item--is-active');

            var $subnavOuter = $(this).siblings('.main-nav__main-nav-item-subnav-outer').first();
            $subnavOuter.css('height', '').css('overflow-y', '');            
        });

        ariaUnhideNonHeaderContent();        
        updateNavAccessibilityElements();

        if ($(document.activeElement).closest('.main-nav__main-nav-item-subnav-outer').length > 0)
        {
            $(document.activeElement).closest('.main-nav__main-nav-item').find('.main-nav__main-nav-item-link').first().focus();
        }
    }

    function updateNavAccessibilityElements() {
        removeFocusableElementRestriction();

        if ((ICF.Utils.Breakpoints.IsMobile() || ICF.Utils.Breakpoints.IsTablet())) {
            if (isHamburgerMenuOpen()) {
                $('.main-nav__hamburger').attr('aria-expanded', 'true');                        
                
                if (isAnySubnavOpen()) {
                    $('.main-nav__main-nav-item-link').attr('aria-hidden', 'true').attr('tabindex', '-1');

                    $('.main-nav__main-nav-item-subnav-outer').not('.main-nav__main-nav-item--is-active .main-nav__main-nav-item-subnav-outer').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
                    $('.main-nav__main-nav-item--is-active .main-nav__main-nav-item-subnav-outer').removeAttr('aria-hidden').find('a').attr('tabindex', '');
                }
                else {
                    $('.main-nav__main-nav-item-link').removeAttr('aria-hidden').attr('tabindex', '').attr('aria-expanded', 'false');
                    $('.main-nav__main-nav-item-subnav-outer').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
                }

                setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn, .main-nav__hamburger, .main-nav__main-nav-item [tabindex=""], .main-nav__main-nav-item-subnav-outer [tabindex=""]'))
            }
            else {
                $('.main-nav__hamburger').attr('aria-expanded', 'false');
            } 
        }
        else {
            $('.main-nav__main-nav-item-link').removeAttr('aria-hidden').attr('tabindex', '');            
            
            if (isAnySubnavOpen()) {
                $('.main-nav__main-nav-item--is-active .main-nav__main-nav-item-link').attr('aria-expanded', 'true');

                $('.main-nav__main-nav-item-subnav-outer').not('.main-nav__main-nav-item--is-active .main-nav__main-nav-item-subnav-outer').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
                $('.main-nav__main-nav-item--is-active .main-nav__main-nav-item-subnav-outer').removeAttr('aria-hidden').find('a').attr('tabindex', '');

                setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn, .main-nav__main-nav-item [tabindex=""], .main-nav__main-nav-item-subnav-outer [tabindex=""]'))
            }
            else {
                $('.main-nav__main-nav-item-link').attr('aria-expanded', 'false');
                $('.main-nav__main-nav-item-subnav-outer').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
            }
        }        
    }       

    function ariaHideNonHeaderContent() {        
        $('main, footer').attr('aria-hidden', 'true');
    }

    function ariaUnhideNonHeaderContent() {        
        $('main, footer').removeAttr('aria-hidden');
    }

    // add the classes that cause tab and shift+tab to be restricted to a subset of elements.
    var setFocusableElementRestriction = function (focusableElements) {
        var firstFocusableElement = focusableElements.first();
        var lastFocusableElement = focusableElements.last();

        $(lastFocusableElement).addClass('focus-trap-focusable-last');
        $(firstFocusableElement).addClass('focus-trap-focusable-first');
    }

    // remove the classes that cause tab and shift+tab to be restricted to a subset of elements.
    var removeFocusableElementRestriction = function () {
        $('.focus-trap-focusable-first').removeClass('focus-trap-focusable-first');
        $('.focus-trap-focusable-last').removeClass('focus-trap-focusable-last');
    }
       
    // close menus when pressing esc
    $(document).on('keyup', function (evt) {
        if (evt.keyCode == 27) {
            // if hamburger is open, close it
            if (isHamburgerMenuOpen()) {
                closeHamburgerMenu();           
            }
            // if search pane is open, close it
            if (isSearchPaneOpen()) {
                closeSearchPane();                
            }
            // if any header nav dropdown is open, close it
            if (isAnySubnavOpen()) {
                closeSubnav(true);
            }
        }
    });
    
    // tab and shift+tab handling
    $(document).on('keydown', function (e) {
        if (isHamburgerMenuOpen() || isSearchPaneOpen() || isAnySubnavOpen()) {
            // if we're tabbing, tab through the focusable elements in the navigation modal.
            if (e.key === 'Tab' || e.keyCode === 9) {
                if ($('.focus-trap-focusable-first.focus-trap-focusable-last').length <= 0) {

                    if (e.shiftKey) /* shift tab keypress */ {
                        if ($(document.activeElement).hasClass('focus-trap-focusable-first')) {
                            $('.focus-trap-focusable-last').focus();
                            e.preventDefault();
                        }
                    } else /* tab keypress */ {
                        if ($(document.activeElement).hasClass('focus-trap-focusable-last')) {
                            $('.focus-trap-focusable-first').focus();
                            e.preventDefault();
                        }
                    }
                } else {
                    e.preventDefault();
                }
            }
        }
    });

    // hamburger menu toggle
    $('.main-nav__hamburger').click(function (e) {
        e.preventDefault();        
        
        if (isHamburgerMenuOpen()) {            
            closeHamburgerMenu();            
        }
        else {            
            if (isSearchPaneOpen()) {
                closeSearchPane();
            }
            
            openHamburgerMenu();
        }
    });

    $('.main-nav__main-nav-item-subnav-back-link').click(function (e) {
        e.preventDefault();
        closeSubnav(false);
    });    

    // main navigation item menu toggle
    $('.main-nav__main-nav-item').not('.main-nav__main-nav-item--with-logo').find('.main-nav__main-nav-item-link:not(.main-nav__main-nav-item-link--standalone)').click(function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('main-nav__main-nav-item--is-active')) {
            closeSubnav(true);
        }
        else {
            if (isSearchPaneOpen()) {
                closeSearchPane();
            }
            else {
                closeSubnav(false);
            }
            openSubnav(this);
        }
    });

    // search pane toggle
    $('.main-nav__search-btn').click(function (e) {
        e.preventDefault();

        if (isSearchPaneOpen()) {
            closeSearchPane();                       
        }
        else {
            if (isAnySubnavOpen()) {
                closeSubnav(false);
            }
            if (isHamburgerMenuOpen()) {
                closeHamburgerMenu();
            }            
            openSearchPane();            
        }
        return false;
    });

    $('.search-wrapper__search-btn').click(function() {
        $(this).closest('form').submit();
    });

    // close header if clicked out of it
    var mainHeaderElement = document.getElementsByClassName('main-header')[0];
    if (typeof mainHeaderElement !== 'undefined') {
        document.addEventListener('click', function (event) {
            if (!mainHeaderElement.contains(event.target)) {
                var modalWrapperElement = document.getElementsByClassName('modaal-wrapper')[0];
                if (typeof modalWrapperElement == 'undefined' || (typeof modalWrapperElement !== 'undefined' && !modalWrapperElement.contains(event.target))) {
                    if (isSearchPaneOpen()) {
                        closeSearchPane();                        
                    }

                    closeSubnav(true);
                }
            }
        });
    }    

    var resetHeaderHeights = function () {
        if (ICF.Utils.Breakpoints.IsMobile() || ICF.Utils.Breakpoints.IsTablet()) {
            $('.main-nav__main-nav-item-subnav-outer').css('height', '').css('overflow-y', '');            
        }
        else {
            var $activeItem = $('.main-nav__main-nav-item.main-nav__main-nav-item--is-active');

            if ($activeItem.length) {
                var $activeSubnavOuter = $activeItem.find('.main-nav__main-nav-item-subnav-outer').first();
                var activeSubnavInnerHeight = $activeSubnavOuter.find('.main-nav__main-nav-item-subnav-inner').outerHeight(true);
                
                if (activeSubnavInnerHeight + 80 <= $('body').outerHeight(true)) {
                    var activeSubnavInnerHeightValue = activeSubnavInnerHeight + 'px';
                    $activeSubnavOuter.css('height', activeSubnavInnerHeightValue).css('overflow-y', '');
                }
                else {
                    $activeSubnavOuter.css('height', 'calc(100% - 80px)').css('overflow-y', 'scroll');                    
                }                
            }           
        }        
    };

    // check to see if header should have class that applies box shadow
    var checkHeaderPosition = function () {
        var $header = $('.main-header');

        if ($(window).scrollTop() > $header.height()) {
            $header.addClass('header--is-scrolled');
            $('body').addClass('header--is-scrolled');
        }
        else {
            $header.removeClass('header--is-scrolled');
            $('body').removeClass('header--is-scrolled');
        }
    };

    $(window).resize(function () {
        if (ICF.Utils.Breakpoints.IsMobile() || ICF.Utils.Breakpoints.IsTablet()) {
            if (isAnySubnavOpen() && !(isHamburgerMenuOpen())) {
                closeSubnav(true);
            }
        }
        else {
            if (isHamburgerMenuOpen()) {
                if (isAnySubnavOpen()) {
                    closeSubnav(true);
                }
                closeHamburgerMenu();
            }
        }

        updateNavAccessibilityElements();
        requestAnimationFrame(resetHeaderHeights);
        updateSearchWrapperHeight();
    });

    $(window).scroll(function () {
        requestAnimationFrame(checkHeaderPosition);
    });
    
    checkHeaderPosition();        
    updateNavAccessibilityElements();    
    updateSearchPaneAccessibilityElements();
};